module.exports = {
  myPets: 'Mein Rudel',
  myProfile: 'Mein Profil',
  logout: 'Ausloggen',
};
